'use strict';

import React, { Component } from 'react';
import { COLOR } from '../App/constants';
import { platformHandler } from '../platforms/PlatformHandler'
import { languageManager } from '../utils/languageManager'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import FwModalLoader from '../components/FwModalLoader';
import {FwScene} from './FwScene'


const emailExp = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

const styles = theme => ({

  paper: {
  	display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    //height: '80%',
    //maxHeight: 480,
    //minHeight: 190,
    width: '80%',
    margin: theme.spacing.unit,
    minWidth: 230,    
    maxWidth: 480,
    borderRadius: '10px',    
    //padding: "32px",

    /*'@media (max-height: 700px)': {
        //height: '95%',
        width: '95%',
      },*/
    //padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  paperNick: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    //height: '35%',
    maxHeight: 480,
    maxWidth: 480,
    minHeight: 190,
    width: '80%',
    margin: theme.spacing.unit,
    minWidth: 230,    
    borderRadius: '10px',    
    
    /*'@media (max-height: 700px)': {
      //height: '90%',
      width: '95%',
    },*/
  },
  paperAccount: {
  	display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    //height: '20%',
    maxHeight: 320,
    maxWidth: 480,
    width: '80%',
    margin: theme.spacing.unit,
    minWidth: 230,
    //minHeight: 100,
    borderRadius: '10px',        
    //padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    marginTop: theme.spacing.unit,
    width: '100%',
    display: "flex",
    flexDirection: "column",
	/*'@media (max-height: 700px)': {
    	transform: 'translateY(20%)',
    },
    '@media (max-height: 580px)': {
    	marginTop: 0,
    	transform: 'none',
    }*/
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  paperTitle: {
    color: 'black',
    //height: '17%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 2px -2px ' + COLOR.FLIPWIT_COLOR_2,
    width: '100%',
  },
  labelNoAccount: {
    display: 'flex',
    alignItems: 'inherit',
    fontSize: '1.3em',
    color: 'black',
    //height: '40%',
    textAlign: 'center',
  },
  labelTitlePaper: {
    display: 'flex',
    alignItems: 'inherit',
    fontSize: '1.3em',
    margin: "8px 0",
    color: COLOR.FLIPWIT_COLOR_2,
  },
  buttonRegister: {
    display: 'flex',
    alignItems: 'inherit',
    fontSize: '1.1em',
    color: '#50738F',
    textTransform: 'none',
    textDecoration: 'underline',
  },
  middleBoxPaper: {
    //height: '55%',
    display: 'flex',
    //Se hace un translate en vez de usar margin ya que
    //el margin de arriba y abajo se calculan con el width
    //y no con el height y eso no sirve
    transform: 'none',
    //margin: '0% 5%',
    fontSize: '0.9em',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    width: '100%',
    padding: "32px",
    /*'@media (min-height: 700px)': {
    	transform: 'translateY(10%)',
    }*/
  },
  bottomBoxPaper: {
    //height: '28%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    backgroundColor: COLOR.FLIPWIT_COLOR_1,
    color: 'white',
    cursor: 'pointer',
    //width: '80%',
    minWidth: 100,
    '&:hover': {
      backgroundColor: COLOR.FLIPWIT_COLOR_2,
     }   
  },
  flipwitContent: {
    //height:'calc(100% - 65px)',
    display: 'flex',    
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',    
    flexDirection: 'column',     
    width: '100%',
  },  
  formControl: {
  	/*'@media (max-height: 700px)': {  		
  		marginTop: 0,
  	}*/
  },
  labelContainer: {
    margin: "16px 0px 0px 0px",
    height: "auto",
  }
});

class ShareOption extends FwScene {
	state = {
	  name: '',
	  email: '',
	  showLoader:false,
	  isChecked:false,
	  showDialog: false,
	  errormsg: '',
	}

	constructor(props) {
	  super(props); 
	  
    console.log('config ', this.props.location.state.config)    

	  
	  
	}

	componentDidMount(){
		platformHandler.checkTitleBarScene("ShareOption");

    let nameLS = '';
    let emailLS = '';
    try{
      console.log('localStorage ', localStorage.getItem( 'nameFW'))
      nameLS = localStorage.getItem( 'nameFW');
      emailLS = localStorage.getItem( 'emailFW');
    }
    catch(e){console.log("Error getting localStorage ShareConfig")}

    setTimeout( () => {
      let name = nameLS ? nameLS : '';
      let email = emailLS ? emailLS : '';  
      console.log('this', this)   
      this.setState({name,email});
    }, 200 )
		//this.focusDiv();
		//document.body.scrollTop = 0;
	}

    focusDiv() {
      ReactDOM.findDOMNode(this.theDiv).focus();      
    }

    /*_setFormValue = (field, val) => {
	    this.setState({ form: { ...this.state.form, [field]: val }})
	  }*/

	handleChangeCheck = event => {
	  this.setState({ isChecked: event.target.checked });
	};

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });    
  };

  
  onSubmit = (ev) => {
    ev.preventDefault();

	  const { location } = this.props;
    //const isShare = location.state.config && location.state.config.shareFinish;

    var emailValid = false;

    if( 
      (this.state.email.indexOf('@')>0) &&
      (this.state.email.lastIndexOf('.')>this.state.email.indexOf('@')) &&
      (this.state.email.indexOf('@')==this.state.email.lastIndexOf('@'))
    ) {
      emailValid = true;
    }

    if( this.state.name == ""){
      this.openModal({title:languageManager.getLangWord("OOPS"),message: languageManager.getLangWord("ENTER_SHARECONFIG")})
      //this.setState({ showDialog: true, errormsg: languageManager.getLangWord("ENTER_SHARECONFIG")});
    }
    else if(this.state.email === "") {
      ReactDOM.findDOMNode(this.emailInput).focus();
      return;
    }
    else if(!emailValid){
      this.openModal({title:languageManager.getLangWord("OOPS"),message: languageManager.getLangWord("LOGIN_ERROR_EMAIL")})     
    }
    else if( /*isShare &&*/ !this.state.isChecked){
			this.openModal({title:languageManager.getLangWord("OOPS"),message: languageManager.getLangWord("ACCEPT_SENT")})
		  //this.setState({ showDialog: true, errormsg: languageManager.getLangWord("ACCEPT_SENT")});
		}
		else{
		  this.setState({ showLoader:true }) 
		  try{
		    localStorage.setItem( 'nameFW', this.state.name);
		    localStorage.setItem( 'emailFW', this.state.email);
		  }
		  catch(e){console.log("Error setting localStorage ShareConfig")}
		  platformHandler.setDataAudience(this.state.email,this.state.name);
		}

	};

  getShareForm = ( classes, isShare ) =>{
    console.log('NAME', this.state.name)
    return (
      <div className={classes.middleBoxPaper}>
        <div style={{marginTop: '10px'}}>{languageManager.getLangWord(isShare ? "DESC_SHARECONFIG" : "DESC_NICKCONFIG")}</div>
      
        <form className={classes.form}>
            <FormControl>
              <TextField 
                id="standard-name"    
                label={languageManager.getLangWord("ENTER_SHARECONFIG") + " *"} 
                autoComplete="username"
                value={this.state.name}
                onChange={this.handleChange('name')}
                disabled={this.state.showLoader}
                margin="normal"
                tabIndex="1"
                 />
            </FormControl>
            <FormControl>
              <TextField 
                id="standard-email"
                label={languageManager.getLangWord("ENTER2_SHARECONFIG") + " *"} 
                autoComplete="email"
                value={this.state.email}
                onChange={this.handleChange('email')}
                disabled={this.state.showLoader}
                margin="normal"
                tabIndex="2"
                inputRef={(emailInput) => { this.emailInput = emailInput; }}
                 />              
            </FormControl>  
            <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.isChecked}
                    onChange={this.handleChangeCheck}
                    value="checkedA"
                    tabIndex="3"
                  />
                }
                label={languageManager.getLangWord("CHECKBOX_SHARECONFIG")}
                className={classes.labelContainer}
            />
            <Button type="submit" variant="contained" className={classes.button} onClick={(ev) => this.onSubmit(ev)}>
              {languageManager.getLangWord("JOIN_BUTTON")}
            </Button>
        </form>
      </div>
    );
  }
	
  	render() {
	  	const { classes, location } = this.props;
      const isShare = location.state.config && location.state.config.shareFinish;

	    return (
	    	<div className={classes.flipwitContent} ref={(child) => { this.theDiv = child; }}>
				{this.state.showLoader && <FwModalLoader />}
				<Paper className={classes.paper}>
					<div className={classes.paperTitle}>
						<div className={classes.labelTitlePaper}>{languageManager.getLangWord("TITLE_SHARECONFIG")}</div>
					</div>

          { this.getShareForm(classes, isShare ) }
				</Paper>
			</div>
    	);
  	}
}

ShareOption.contextTypes = {
  store: PropTypes.object
};

ShareOption.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,
};

const mapStateToProps = state => {  	
  return {
  	language: state.containers.appReducer.language,    
  }
};

export default connect(mapStateToProps)(withStyles(styles,{ withTheme: true })(ShareOption));



// WEBPACK FOOTER //
// ./src/containers/scenes/ShareOption.js